import React, { Fragment } from 'react';
import Card from './components/Card';
import Header from './components/Header';

export default function Operations() {
    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt--6">
                <div className="row">
                    <div className="col">
                        <Card />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/ZWallet/Operations/index.js